import { User } from "../global-components/src/types";
import { Post } from "../types";

/**
 * Mock promotional posts shown in the feed.
 * Each entry appears at most once per week (controlled by localStorage).
 * At most ONE promo post is injected per feed load.
 *
 * Rules:
 * - id must be negative (so they never collide with real post IDs)
 * - shown at most once per 7 days (per post id)
 * - only one promo post per feed render
 */
const baseUser: Omit<User, "id" | "name" | "user_name" | "img_account" | "site" | "stamps" | "user_id"> = {
    verified_profile: 1,
    position: 1,
    biography: "",
    total_posts: 0,
    total_followers: 0,
    total_following: 0,
    total_comments: 0,
    total_videos_youtube: 0,
    total_poems: 0,
    total_books_publish: 0,
    is_following: false,
    is_followed: false,
    is_blocked: false,
    is_muted: false,
    is_banned: false,
    is_visible: true,
    can_ban_user: false,
    can_edit_permissions: false,
    can_remove_photo: false,
    can_send_warn: false,
    can_delete_account: false,
    email: "",
    phone: "",
    privacy: 0,
    session_id: "",
    token: "",
    pinned_post_id: 0,
    email_verified_at: new Date(),
    created_at: new Date(),
    next_payment: new Date(),
    birth_date: new Date(),
};

const pacocaUser: User = {
    ...baseUser,
    id: 2,
    user_id: 2,
    name: "Paçoca",
    user_name: "pacoca",
    img_account: "storage/img_account/6a7efeef7fd6f.png",
    site: "pacoca.net",
    stamps: ["black", "blue"],
};


const versonaUser: User = {
    ...baseUser,
    id: 17095,
    user_id: 17095,
    name: "Versona",
    user_name: "versona",
    img_account: "storage/img_account/69e2e572b4966.png",
    site: "versona.pacoca.net",
    stamps: ["blue"],
};

const reflexoUser: User = {
    ...baseUser,
    id: 17095,
    user_id: 17095,
    name: "Reflexo",
    user_name: "reflexo",
    img_account: "storage/img_account/6a1dc23708811.png",
    site: "reflexo.pacoca.net",
    stamps: ["blue"],
};

const PROMO_POSTS: Post[] = [
    {
        id: -1,
        id_user: 2,
        type: "post",
        original_post_id: 0,
        group_id: null,
        total_likes: 0,
        total_shares: 0,
        total_comments: 0,
        text: "O Paçoca é grátis e sem anúncios. Doe ou compre o verificado pra ajudar a manter os servidores e a comunidade. 💛 \nAbra o menu e vá em Doação ou Premium",
        liked: false,
        user_is_blocked: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        content: "",
        images: [],
        user: pacocaUser,
        original_post: null as any,
        poll: null as any,
        group: null as any,
    },
    {
        id: -4,
        id_user: 17095,
        type: "post",
        original_post_id: 0,
        group_id: null,
        total_likes: 0,
        total_shares: 0,
        total_comments: 0,
        text: "Publique poesias no Versona, elas são publicadas no Paçoca também. \n@versona",
        liked: false,
        user_is_blocked: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        content: "",
        images: [{ id_post: -4, path: versonaUser.img_account, type: 0, id: -4 }],
        user: versonaUser,
        original_post: null as any,
        poll: null as any,
        group: null as any,
    },
    {
        id: -5,
        id_user: 17095,
        type: "post",
        original_post_id: 0,
        group_id: null,
        total_likes: 0,
        total_shares: 0,
        total_comments: 0,
        text: "Reflexo é o Instagram 2.0, a rede social de imagens do Paçoca com os posts sincronizados. \n@reflexo",
        liked: false,
        user_is_blocked: false,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        content: "",
        images: [{ id_post: -5, path: reflexoUser.img_account, type: 0, id: -5 }],
        user: reflexoUser,
        original_post: null as any,
        poll: null as any,
        group: null as any,
    },
];

const PROMO_KEY_PREFIX = "promo_post_last_shown_";
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

/** Returns the single promo post to inject this session, or null if none is due. */
export function getPromoPost(): Post | null {
    for (const post of PROMO_POSTS) {
        const key = `${PROMO_KEY_PREFIX}${post.id}`;
        const lastShown = localStorage.getItem(key);
        const now = Date.now();

        if (!lastShown || now - Number(lastShown) >= ONE_WEEK_MS) {
            localStorage.setItem(key, String(now));
            return post;
        }
    }
    return null;
}
